import tileRomaTiburtina01 from "assets/easy/AV_ROMA_TIBURTINA/01.jpg";
import tileRomaTiburtina02 from "assets/easy/AV_ROMA_TIBURTINA/02.jpg";
import tileRomaTiburtina03 from "assets/easy/AV_ROMA_TIBURTINA/03.jpg";
import tileRomaTiburtina04 from "assets/easy/AV_ROMA_TIBURTINA/04.jpg";
import tileRomaTiburtina05 from "assets/easy/AV_ROMA_TIBURTINA/05.jpg";
import tileRomaTiburtina06 from "assets/easy/AV_ROMA_TIBURTINA/06.jpg";
import tileRomaTiburtina07 from "assets/easy/AV_ROMA_TIBURTINA/07.jpg";
import tileRomaTiburtina08 from "assets/easy/AV_ROMA_TIBURTINA/08.jpg";
import tileRomaTiburtina09 from "assets/easy/AV_ROMA_TIBURTINA/09.jpg";
import tileRomaTiburtina10 from "assets/easy/AV_ROMA_TIBURTINA/10.jpg";
import tileRomaTiburtina11 from "assets/easy/AV_ROMA_TIBURTINA/11.jpg";
import tileRomaTiburtina12 from "assets/easy/AV_ROMA_TIBURTINA/12.jpg";
import tileRomaTiburtina13 from "assets/easy/AV_ROMA_TIBURTINA/13.jpg";
import tileRomaTiburtina14 from "assets/easy/AV_ROMA_TIBURTINA/14.jpg";
import tileRomaTiburtina15 from "assets/easy/AV_ROMA_TIBURTINA/15.jpg";
import tileRomaTiburtina16 from "assets/easy/AV_ROMA_TIBURTINA/16.jpg";
import fullImage from "assets/easy/AV_ROMA_TIBURTINA/complete.jpg";

import { ILevel, LevelDifficulties, LevelTypes } from "models";

export const romaTiburtina: ILevel = {
  difficulty: LevelDifficulties.easy,
  type: LevelTypes.station,
  name: "AV Roma Tiburtina",
  fullImage,
  successDialogContent: {
    subtitle: "Hai (ri)costruito la stazione AV ROMA TIBURTINA",
    link: `https://www.fsitaliane.it/content/fsitaliane/it/innovazione/tecnologie-per-i-trasporti/le-principali-stazioni-av/roma-tiburtina.html`,
    contents: [
      {
        text: "500 treni",
        isBold: true,
      },
      {
        text: " al giorno, ",
        isBold: false,
      },
      {
        text: "140 mila transiti",
        isBold: true,
      },
      {
        text: " giornalieri e ",
        isBold: false,
      },
      {
        text: "51 milioni di utenti",
        isBold: true,
      },
      {
        text: " all’anno: la stazione AV Roma Tiburtina è uno ",
        isBold: false,
      },
      {
        text: "snodo fondamentale",
        isBold: true,
      },
      {
        text:
          " che mette in collegamento la capitale con tutta l’Italia. Di particolare interesse è la ",
        isBold: false,
      },
      {
        text: "grande galleria vetrata",
        isBold: true,
      },
      {
        text:
          ", un’infrastruttura avveniristica sopraelevata che collega i quartieri di Pietralata e Nomentano. Dal punto di vista della mobilità, la stazione si è affermata come ",
        isBold: false,
      },
      {
        text: "crocevia di scambio essenziale",
        isBold: true,
      },
      {
        text:
          " all’interno della rete viaria urbana, permettendo allo stesso tempo una ",
        isBold: false,
      },
      {
        text: "migliore integrazione",
        isBold: true,
      },
      {
        text: " con i trasporti su gomma.",
        isBold: false,
      },
    ],
  },
  tiles: [
    tileRomaTiburtina01,
    tileRomaTiburtina02,
    tileRomaTiburtina03,
    tileRomaTiburtina04,
    tileRomaTiburtina05,
    tileRomaTiburtina06,
    tileRomaTiburtina07,
    tileRomaTiburtina08,
    tileRomaTiburtina09,
    tileRomaTiburtina10,
    tileRomaTiburtina11,
    tileRomaTiburtina12,
    tileRomaTiburtina13,
    tileRomaTiburtina14,
    tileRomaTiburtina15,
    tileRomaTiburtina16,
  ],
};
